import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ADMIN_NAV_GROUPS } from '../../admin/adminRegistry';
import '../../pages/AdminDashboard.css';
import './AdminShell.css';
import './AdminHubUiKit.css';

function AdminShell() {
  const { t, isRTL } = useLanguage();

  return (
    <div className={`admin-shell-root ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <aside className="admin-shell-sidebar" aria-label={t('adminHub.sidebarAria')}>
        <div className="admin-shell-brand">
          <div className="admin-shell-brand__title">{t('adminHub.shellTitle')}</div>
          <div className="admin-shell-brand__sub">{t('adminHub.shellSubtitle')}</div>
        </div>
        <nav className="admin-shell-nav">
          {ADMIN_NAV_GROUPS.map((group) => (
            <div key={group.id} className="admin-shell-nav__group">
              <div className="admin-shell-nav__group-title">{t(group.titleKey)}</div>
              <ul className="admin-shell-nav__list">
                {group.items.map((item) => (
                  <li key={item.id}>
                    <NavLink
                      to={item.path}
                      end={!!item.navExact}
                      className={({ isActive }) =>
                        `admin-shell-nav__link${isActive ? ' admin-shell-nav__link--active' : ''}`
                      }
                    >
                      {t(item.labelKey)}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </aside>
      <main className="admin-shell-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminShell;
